import { InputSkeleton } from '@/_components';
import {
  CardContainer,
  Container,
  ContainerLayout,
  FormLayout,
  LeftSection,
  SectionHeadingSkeleton,
  StickyPageHeaderSkeletonWithButtons,
} from '@/_containers';

export default function Loading() {
  return (
    <ContainerLayout>
      <StickyPageHeaderSkeletonWithButtons numberOfButtons={0} />

      <Container>
        <LeftSection>
          <CardContainer>
            <SectionHeadingSkeleton />

            <FormLayout>
              <InputSkeleton className="col-span-12 sm:col-span-6" />
              <InputSkeleton className="col-span-12 sm:col-span-6" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />

              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />

              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
            </FormLayout>
          </CardContainer>
        </LeftSection>
      </Container>
    </ContainerLayout>
  );
}
